import alt from "../alt";
import ContactActions from "../actions/contactActions";

class ContactStore {
	constructor() {
		this.formState = "Idle";
		this.error = {};
		this.info = {};

		this.bindListeners({
			handleSendEmail: ContactActions.SEND_EMAIL,
			handleSuccess: ContactActions.ON_SUCCESS,
			handleError: ContactActions.ON_ERROR
		});
	}

	handleSendEmail() {
		// console.log('handleSendEmail');
		this.formState = "working";
	}

	handleSuccess({ email, info }) {
		// console.log('handleSuccess');
		this.formState = "success";
		this.info = info;
	}

	handleError({ email, error }) {
		// console.log('handleError')
		(this.formState = "error"), (this.error = error);
	}
}

module.exports = alt.createStore(ContactStore, "ContactStore");
